import script from "./AllSurveys.vue?vue&type=script&setup=true&lang=js"
export * from "./AllSurveys.vue?vue&type=script&setup=true&lang=js"

import "./AllSurveys.vue?vue&type=style&index=0&id=56347fb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56347fb4"]])

export default __exports__